export default __webpack_public_path__ + "images/TG.2118e25.png";